import { DocumentNode } from '@apollo/client';

import { useQuery } from '@ts-core/lib/apollo';
import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { getSubjectStatsQuery, GetSubjectStatsQueryResult, GetSubjectStatsQueryVariables } from '../graphql/queries/getSubjectStatsQuery';

interface SubjectStatsHookInput {
  courseId: string;
  subjectId: string;

  fragment: DocumentNode;
}

interface SubjectStatsHookOutput<TSubjectStats> {
  subject?: TSubjectStats;

  loading: boolean;
  error?: string;
  onRefetchStats: () => void;
}

export default function useSubjectStats<TSubjectStats>(input: SubjectStatsHookInput): SubjectStatsHookOutput<TSubjectStats> {
  const { courseId, subjectId, fragment } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { loading, data, error, refetch } = useQuery<GetSubjectStatsQueryResult<TSubjectStats>, GetSubjectStatsQueryVariables>(
    getSubjectStatsQuery(fragment),
    {
      variables: { courseId, subjectId },
      onError: showErrorNotification,
    }
  );

  return {
    subject: data?.subject,
    loading,
    error: getErrorMessage({ error }),

    onRefetchStats: refetch,
  };
}
